import React from "react";
import { Image } from "react-bootstrap";

export default function DashboardCounter(props) {
  const {
    mainIcon,
    activeIcon,
    inactiveIcon,
    title,
    total,
    subTitleOne,
    subTitleTwo,
    link,
  } = props;
  const doRedirect = () => {
    window.location.href = link;
  };
  return (
    <div
      className="flex flex-col w-full bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-3 shadow-sm hover:shadow-md transition-shadow"
      style={{ minHeight: "120px", cursor: "pointer" }}
      onClick={() => (link !== null ? doRedirect() : null)}
    >
      <div className="flex items-center gap-3 mb-1.5">
        <div className="flex items-center justify-center w-[38px] h-[38px] rounded-xl bg-[#EFF6FF] flex-shrink-0">
          <Image
            src={mainIcon}
            style={{ width: "24px", height: "24px" }}
          />
        </div>
        <p
          className="mb-0 text-[13px] uppercase tracking-wide font-medium text-[#64748B] font-poppins"
          style={{
            fontSize: props.fontSize ? props.fontSize : null,
          }}
        >
          {title}
        </p>
      </div>
      <div>
        <h3 className="mb-0 text-[26px] leading-tight font-bold text-[#171717] font-poppins">
          {total}
        </h3>
      </div>
      {!props.showBottom ? null : (
        <div className="flex items-center justify-between gap-2 mt-2 pt-2 border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9]">
          <div className="flex items-center gap-1.5">
            <Image
              src={activeIcon}
              style={{ width: "15px", height: "15px" }}
            />
            <span className="text-[12px] text-[#334155] font-normal font-poppins">
              {subTitleOne}
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <Image
              src={inactiveIcon}
              style={{ width: "15px", height: "15px" }}
            />
            <span className="text-[12px] text-[#334155] font-normal font-poppins">
              {subTitleTwo}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
